export var USER_LOGIN = 'AOR/USER_LOGIN';
export var USER_LOGIN_LOADING = 'AOR/USER_LOGIN_LOADING';
export var USER_LOGIN_FAILURE = 'AOR/USER_LOGIN_FAILURE';
export var USER_LOGIN_SUCCESS = 'AOR/USER_LOGIN_SUCCESS';
export var userLogin = function userLogin(payload, pathName) {
  return {
    type: USER_LOGIN,
    payload: payload,
    meta: {
      auth: true,
      pathName: pathName
    }
  };
};
export var USER_CHECK = 'AOR/USER_CHECK';
export var userCheck = function userCheck(payload, pathName) {
  return {
    type: USER_CHECK,
    payload: payload,
    meta: {
      auth: true,
      pathName: pathName
    }
  };
};
export var USER_LOGOUT = 'AOR/USER_LOGOUT';
export var userLogout = function userLogout() {
  return {
    type: USER_LOGOUT,
    meta: {
      auth: true
    }
  };
};